import { createContext } from "react";

/**
 * DOM node (inside the drawer) that nested Radix popups (e.g. the date picker
 * Popover) portal into, so they stay within vaul's interactive subtree —
 * otherwise, portaled to `body`, they render outside the modal drawer and their
 * clicks are swallowed.
 */
const PlanDrawerContainerContext = createContext<HTMLElement | null>(null);

/**
 * z-index for popups (Popover/Select) opened from within the drawer, so they
 * render above vaul's overlay instead of behind it.
 */
export const PLAN_DRAWER_POPOVER_CLASS = "z-1500";

export default PlanDrawerContainerContext;
